import { publishTags } from "redux/slices/lensEditor";
import { useAppDispatch } from "redux/hooks";
import { useCallback, useState } from "react";
import { PublishTagsUpdate } from "generated/graphql";
import { PublishModal } from "routes/lens-editor/PublishModal";

function PublishTagsHelperText() {
  return (
    <div className="*:py-1">
      <p className="text-sm">Publish tags to the following lenses?</p>
      <p className="text-xs italic">
        This will create tags that are missing in the target lens as well as overwrite Name, Color and Description for
        existing tags (matched based on the System Name).
      </p>
    </div>
  );
}

type PublishTagsModalProps = {
  lensId: number;
  open: boolean;
  close: () => void;
};

const PublishTagsModal = (props: PublishTagsModalProps) => {
  const { lensId } = props;
  const dispatch = useAppDispatch();
  const [updateInfo, setUpdateInfo] = useState<PublishTagsUpdate[]>([]);
  const [dryrun, setDryrun] = useState(true);
  const [error, setError] = useState("");
  const [disabled, setDisabled] = useState(false);

  const handlePublish = async (dryrun: boolean, onlyPublishLensIds: number[]) => {
    setDisabled(true);
    setDryrun(dryrun);
    return dispatch(
      publishTags({
        lensId: lensId,
        dryrun: dryrun,
        onlyPublishLensIds: onlyPublishLensIds,
      })
    )
      .unwrap()
      .then((response) => {
        setUpdateInfo(response.lens.form.publishTags.updateInfo);
        setError("");
        setDisabled(false);
      })
      .catch((e) => {
        setError(e.message);
        setDisabled(false);
      });
  };

  const dryrunOnMount = useCallback(() => {
    handlePublish(true, []);
  }, []);

  return (
    <PublishModal
      ref={dryrunOnMount}
      open={props.open}
      error={error}
      dryrun={dryrun}
      isDisabled={disabled}
      updateInfo={updateInfo}
      close={props.close}
      publish={(onlyPublishLensIds: number[]) => handlePublish(false, onlyPublishLensIds)}
      header="Publish Tags"
      text={<PublishTagsHelperText />}
    />
  );
};

export default PublishTagsModal;
